angular
	.module 'App.Module.Home', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'home',
				url: '/home'
				views:
					"main":
						controller: 'HomeController'
						controllerAs: 'vm'
						templateUrl: '@app/home/home.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Home'
